import React ,{ lazy}from 'react'
import NavBar from './common/NavBar'
import approval from '../../assets/approval.png'
import { useNavigate } from 'react-router-dom'


const Success = () => {
    const navigate=useNavigate();

    const handleSubmit=async()=>{
            navigate("/login")
    }
 
  return (
    <div className='get-started'>
         <NavBar/>
         <div className='registration-form' >
                
                <img src={approval} alt='approval'  loading={lazy} style={{width:"120px",height:"120px"}}/>
                <p className='check-email-heading'>Sign up completed successfully</p>
                <div className='check-email-desc'>
                <p>Explore features & better your future</p>
                </div>
                <div className='register-form'>
                    <button type='submit' className='button-theme success-submit'
                    style={{backgroundColor:"rgba(45, 118, 253, 1)"}}
                     onClick={handleSubmit}>Go to Login</button>
                </div>
                 </div>

    </div>
    

  )
}

export default Success;